const SPEECH_STATE_KEY = "__PDX_SPEECH_PRIMER_STATE__";

const IOS_WEBKIT_RE =
  /iP(hone|ad|od)/i;

function isIosWebKit() {
  return (
    typeof navigator !== "undefined" &&
    (IOS_WEBKIT_RE.test(navigator.userAgent || "") ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1))
  );
}

function getPrimerState() {
  if (typeof window === "undefined") {
    return { primed: false, primeStarted: null };
  }

  const existing = window[SPEECH_STATE_KEY];
  if (existing && typeof existing === "object") {
    if (typeof existing.primed !== "boolean") existing.primed = false;
    if (
      existing.primeStarted !== null &&
      typeof existing.primeStarted !== "boolean"
    ) {
      existing.primeStarted = null;
    }
    return existing;
  }

  const seeded = {
    primed: false,
    primeStarted: null,
    speechGeneration: 0,
  };
  window[SPEECH_STATE_KEY] = seeded;
  return seeded;
}

function getSpeechSynthesis() {
  if (typeof window === "undefined") return null;
  return window.speechSynthesis || null;
}

function isSpeechSupported() {
  return (
    !!getSpeechSynthesis() &&
    typeof window !== "undefined" &&
    typeof window.SpeechSynthesisUtterance === "function"
  );
}

export function primeGlobalSpeechSynthesis() {
  const state = getPrimerState();
  if (state.primed && state.primeStarted === true) return true;

  const synth = getSpeechSynthesis();
  if (!isSpeechSupported() || !synth) return false;

  try {
    const utterance = new window.SpeechSynthesisUtterance(" ");
    utterance.onstart = () => {
      state.primeStarted = true;
    };
    utterance.onerror = () => {
      state.primeStarted = false;
    };
    synth.speak(utterance);
    state.primed = true;
  } catch {
    return false;
  }

  return state.primed;
}

export function installGlobalSpeechPrimer(target) {
  const state = getPrimerState();
  const node =
    target || (typeof document !== "undefined" ? document : null);

  if (state.primed || !node || typeof node.addEventListener !== "function") {
    return () => {};
  }

  const events = isIosWebKit()
    ? ["touchend", "click"]
    : ["pointerdown", "touchend", "click"];

  const teardown = () => {
    for (const type of events) {
      node.removeEventListener(type, onGesture, true);
    }
  };

  function onGesture() {
    primeGlobalSpeechSynthesis();
    teardown();
  }

  for (const type of events) {
    node.addEventListener(type, onGesture, true);
  }

  return teardown;
}
